import styled from 'styled-components';

export const Hidden = styled('div')`
  display: none;
`;
